import React from 'react';
import { Platform, View } from 'react-native';
import { HugeiconsIcon, HugeiconsProps } from '@hugeicons/react-native';
import { cssInterop } from 'nativewind';

// Apply cssInterop for NativeWind className styling
cssInterop(HugeiconsIcon, {
  className: {
    target: 'style',
    nativeStyleToProp: {
      color: true,
    },
  },
});

export function HugeIconsWrapper({ className, style, ...props }: HugeiconsProps & { className?: string }) {
  if (Platform.OS === 'web') {
    // On web, wrap in a View to ensure styles (class names) are applied to a container
    // and let the Icon inherit the text color via 'currentColor'.
    // We pass className/style to the wrapper View.
    const color = props.color || 'currentColor';
    return (
      <View className={className} style={style}>
        <HugeiconsIcon {...props} color={color} style={undefined} />
      </View>
    );
  }

  return <HugeiconsIcon className={className} style={style} {...props} />;
}
